import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Change element colour on scroll

function changeColorScroll() {
  const sections = gsap.utils.toArray("section");
  const back = document.getElementById("back");
  const logo = document.getElementById("logo");
  const SearchToggle = document.getElementById("toggle");
  const userLogin = document.getElementById("user-login");
  const mainMenu = document.getElementById("menu-primary-menu");
  const header = document.querySelector("header");

  const RGBToHSL = (r, g, b) => {
    r /= 255;
    g /= 255;
    b /= 255;

    const l = Math.max(r, g, b);
    const s = l - Math.min(r, g, b);
    const h = s
      ? l === r
        ? (g - b) / s
        : l === g
        ? 2 + (b - r) / s
        : 4 + (r - g) / s
      : 0;
    return (100 * (2 * l - s)) / 2;
  };

  function changeLogo(sec) {
    let rgbColor = getComputedStyle(sec).backgroundColor;

    if (rgbColor.startsWith("rgba")) {
      // Handle transparent background color (if needed)
    } else {
      let rgbArr = rgbColor
        .substring(4, rgbColor.length - 1)
        .replace(/ /g, "")
        .split(",");
      let l = RGBToHSL(
        parseInt(rgbArr[0]),
        parseInt(rgbArr[1]),
        parseInt(rgbArr[2])
      );

      if (logo) {
        if (l < 53) {
          logo.classList.add("color-change");
        } else {
          logo.classList.remove("color-change");
        }
      }

      if (back) {
        if (l < 53) {
          back.classList.add("color-change");
        } else {
          back.classList.remove("color-change");
        }
      }

      if (SearchToggle) {
        if (l < 53) {
          SearchToggle.classList.remove("color-change");
        } else {
          SearchToggle.classList.add("color-change");
        }
      }

      if (userLogin) {
        if (l < 53) {
          userLogin.classList.remove("color-change");
        } else {
          userLogin.classList.add("color-change");
        }
      }

      if (header) {
        if (l < 53) {
          header.classList.remove("color-change");
        } else {
          header.classList.add("color-change");
        }
      }

      if (mainMenu) {
        if (l < 53) {
          mainMenu.classList.remove("color-change");
        } else {
          mainMenu.classList.add("color-change");
        }
      }
    }
  }

  function setupScrollTriggers() {
    sections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        markers: false,
        start: "top 40",
        end: "bottom 40",
        onEnter: () => changeLogo(section),
        onEnterBack: () => changeLogo(section),
      });
    });

    // Apply correct header/logo colors on first paint (before any scroll event).
    const initialSection =
      sections.find((section) => {
        const rect = section.getBoundingClientRect();
        return rect.top <= 40 && rect.bottom > 40;
      }) || sections[0];

    if (initialSection) {
      changeLogo(initialSection);
    }
  }

  function handleResize() {
    const mq = window.matchMedia("(min-width: 1024px)");

    if (mq.matches) {
      setupScrollTriggers();
    }
  }

  handleResize();

  window.addEventListener("resize", () => {
    handleResize();
  });
}

export { changeColorScroll };

// Scrolling marquee

const marquee = () => {
  const marqueeContainer = document.querySelector(".marquee__inner");
  const marqueePart = document.querySelectorAll(".marquee__part");

  if (marqueePart && marqueeContainer) {
    if (marqueePart.length) {
      let totalWidth = 0;

      // Calculate total width of all items including margin
      marqueePart.forEach((part) => {
        totalWidth += part.offsetWidth + 10; // Adjust margin as needed
      });

      // Set container width to fit all items
      marqueeContainer.style.width = `${totalWidth * 2}px`;

      // Duplicate the elements to create an infinite effect
      marqueePart.forEach((part) => {
        let clone = part.cloneNode(true);
        marqueeContainer.appendChild(clone);
      });

      const velocity = 75;
      const duration = (totalWidth * 2) / velocity;

      // Animate the marquee
      let tween = gsap.to(".marquee__inner", {
        x: -totalWidth,
        ease: "linear",
        duration: duration,
        repeat: -1,
        modifiers: {
          x: (x) => (parseFloat(x) % totalWidth) + "px",
        },
      });

      // Control the animation speed based on scroll direction
      let lastScrollTop = 0;
      window.addEventListener(
        "scroll",
        function () {
          let st = window.pageYOffset || document.documentElement.scrollTop;
          if (st > lastScrollTop) {
            // Down scroll
            gsap.to(tween, { timeScale: 1 });
          } else {
            // Up scroll
            gsap.to(tween, { timeScale: -1 });
          }
          lastScrollTop = st <= 0 ? 0 : st;
        },
        false
      );
    }
  }
};

marquee();

export { marquee };

const textMarquee = () => {
  const marqueeContainer = document.querySelector(".text-marquee__inner");
  if (!marqueeContainer || marqueeContainer.dataset.marqueeInit) return;

  const marqueePart = marqueeContainer.querySelectorAll(".text-marquee__part");
  if (!marqueePart.length) return;

  marqueeContainer.dataset.marqueeInit = "true";

  let totalWidth = 0;
  marqueePart.forEach((part) => {
    totalWidth += part.offsetWidth + 10;
  });

  if (!totalWidth) return;

  marqueeContainer.style.width = `${totalWidth * 2}px`;

  marqueePart.forEach((part) => {
    marqueeContainer.appendChild(part.cloneNode(true));
  });

  const velocity = 60;
  const duration = totalWidth / velocity;

  gsap.killTweensOf(marqueeContainer);

  // Start on the cloned half and move to 0 so the text travels forwards
  const tween = gsap.fromTo(
    marqueeContainer,
    { x: -totalWidth },
    {
      x: 0,
      ease: "none",
      duration: duration,
      repeat: -1,
    }
  );

  let lastScrollTop = 0;
  window.addEventListener(
    "scroll",
    function () {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      tween.timeScale(st > lastScrollTop ? 1 : -1);
      lastScrollTop = st <= 0 ? 0 : st;
    },
    { passive: true }
  );
};

export { textMarquee };
